import Vue from 'vue'
import {Carousel} from 'buefy'
import VisProcess from './components/VisProcess'
import GallerySlider from './components/GallerySlider'
import VueAnimateOnScroll from 'vue-animate-onscroll'
import CustomerSlider from './components/CustomerSlider'

import './assets/scss/app.scss'
import './assets/scss/fix.scss'
import 'animate.css'
import checkView from 'vue-check-view'

Vue.use(Carousel, { defaultIconPack: 'fas' })
Vue.use(VueAnimateOnScroll)
Vue.use(checkView)
Vue.component('vis-process', VisProcess)
Vue.component('customer-slider', CustomerSlider)
Vue.component('gallery-slider', GallerySlider)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#main-content'
})
